import { Link } from "react-router-dom";
import { API } from "@/lib/api";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";

export const img = (u) => (u && u.startsWith("/api/") ? `${API}${u.slice(4)}` : u && u.startsWith("/") ? `${window.location.origin}${u}` : u);

export const clean = (t) => (t || "").replace(/\s*learn more at savingamericamoney\.com\.?\s*$/i, "").trim();

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export function setMeta(name, content, attr = "name") {
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute("content", content || "");
}

export function useFeedLink(href) {
  useEffect(() => {
    if (!href) return undefined;
    const el = document.createElement("link");
    el.rel = "alternate";
    el.type = "application/rss+xml";
    el.title = "Saving America Money Podcast";
    el.href = href;
    el.dataset.podcastFeed = "1";
    document.head.appendChild(el);
    return () => { el.remove(); };
  }, [href]);
}

const LABELS = { apple: "Apple Podcasts", spotify: "Spotify", amazon: "Amazon Music", youtube: "YouTube Music" };

export function ListenOn({ links }) {
  if (!Object.keys(LABELS).some((k) => links?.[k])) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="podcast-listen-on">
      {Object.keys(LABELS).filter((k) => links?.[k]).map((k) => (
        <a key={k} href={links[k]} target="_blank" rel="noreferrer" className="rounded-full border border-sam-navy/20 bg-white px-4 py-2 text-sm font-semibold text-sam-navy transition-colors hover:bg-sam-navy hover:text-white" data-testid={`listen-${k}`}>{LABELS[k]}</a>
      ))}
    </div>
  );
}

export function AudioPlayer({ ep, testid }) {
  return (
    <audio controls preload="none" className="w-full" data-testid={testid}>
      <source src={ep.audio_url} type={ep.audio_type || "audio/mpeg"} />
      Your browser can't play this episode.
    </audio>
  );
}

export function PodcastCTA() {
  return (
    <div className="rounded-2xl bg-sam-navy p-6 sm:p-8 text-sam-cream" data-testid="podcast-cta">
      <div className="sam-flag-bar mb-4 h-1 w-16" />
      <p className="font-display text-xl sm:text-2xl font-bold leading-snug">Want to know if your category is still open on a route near you?</p>
      <Link to="/mailer" className="mt-4 inline-flex items-center gap-2 rounded-full bg-sam-crimson px-5 py-3 font-semibold text-white transition-transform hover:-translate-y-0.5" data-testid="podcast-cta-btn">Request your free route availability check<ArrowRight className="h-4 w-4" /></Link>
    </div>
  );
}
